import createError from 'http-errors';
import * as CONFIG from '@/config';
import type {BunRequest} from 'bun';

export function exceleraApiClient(req?: BunRequest) {
  const EXCELERA_BASE_URL = process.env.EXCELERA_BASE_URL || 'https://omeo.carlton.kongkers.net';

  const baseOptions: RequestInit = {};
  const cookies: any = {};
  if(CONFIG.PROXY_CONFIG) {
    baseOptions.proxy = CONFIG.PROXY_CONFIG;
  }
  if(req) {
    const cookieHeader = req.headers.get('cookie');
    if(cookieHeader) {
      cookies.Cookie = cookieHeader;
    }
  }
  return async function(url: string, options: RequestInit = { method: 'GET' }) {
    const startTs = Date.now();
    const requestUrl = `${EXCELERA_BASE_URL}${url}`;
    const requestOptions = {
      ...baseOptions,
      headers: {
        'Content-Type': 'application/json',
        ...cookies,
      },
      ...options,
    }
    const resp = await fetch(requestUrl, requestOptions);
    const data = await resp.json();
    if(!resp.ok) {
      throw createError(resp.status, data.message);
    }
    const endTs = Date.now();
    const duration = endTs - startTs;
    console.log(`[--- FETCH ---] ${requestOptions.method?.toUpperCase()} - ${requestUrl} - [${resp.status}] - [${duration}ms]`)
    return data;
  }
}
